<script>
  import {onMount, onDestroy} from 'svelte'
  import gsap from 'gsap'
  import ScrollTrigger from 'gsap/ScrollTrigger'

  export let start = 'top 70%'
  export let toggleActions = 'play play play pause'
  export let stagger = .2
  export let delay = 0

  let self, st;

  $: className = 'bullets' + ($$props.class ? ' ' + $$props.class : '')

  onMount(() => {
    const tl = gsap.timeline()
    tl.from(
      self.querySelectorAll('li'),
      {
        y: 30,
        opacity: 0,
        duration: 0.5,
        ease: 'power2.out',
        stagger,
      },
      delay
    )
    st = ScrollTrigger.create({
      trigger: self,
      start,
      toggleActions,
      animation: tl
    })
  })

  onDestroy(() => {
    st?.kill()
  })

</script>
<ul class={className} bind:this={self}>
  <slot></slot>
</ul>

<style>
  ul :global(li) {
    margin: 1rem 0;
  }
</style>